module.exports = __webpack_public_path__ + "static/media/IMG_20190826_153823.thumbnail.72ffeb09.png";